import {
  DRIVER_STATUSES,
  STATUSES,
  ORDER_STATUSES,
  ORDER_STATUS,
  FILTER_CHIPS,
  DELIVERY_EXECUTION_STATUS,
  DEFAULT_FILTER_CHIP,
  ALL_FILTER_CHIP,
  NON_EDITABLE_STATUSES,
  REFRESHABLE_STATUSES,
  DRIVER_ASSIGNED_SUCCESS_MSG,
  DEFAULT_STATUS_SELECTION,
  PARTIALLY_DELIVERED,
  REPLANNING_CONSIGNMENT_SUCCESS_MSG,
  ADDRESS_MARKED_UNVERIFIED,
  DRIVER_SHARED_CONSTANTS,
} from "./SharedConstants/ExpressSharedConstants";

const CustomerCommConstants = {
  CUSTOMER_COMM_CONSTANTS: {
    CONSIGNMENTS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Consignments",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "hubCode",
            headerName: "Hub",
            width: 100,
          },
          {
            field: "hubNames",
            headerName: "Hub Name",
            width: 150,
          },
          {
            field: "consignmentId",
            headerName: "Consignment ID",
            width: 100,
          },
          {
            field: "deliveryArea",
            headerName: "Customer Area",
            width: 150,
            tooltip: true,
            tooltipDataKey: "address",
          },
          {
            field: "deliveryZone",
            headerName: "Zone",
            width: 100,
          },
          {
            field: "status",
            headerName: "Status",
            width: 186,
          },
          {
            field: "deliveryType",
            headerName: "Type",
            width: 100,
          },
          {
            type: "date",
            field: "deliveryDate",
            headerName: "Delivery Date",
            width: 100,
          },
          {
            field: "deliverySlotTime",
            headerName: "Delivery Slot",
            width: 100,
          },
        ],

        FilterFormData: [
          {
            type: "selectBox",
            fieldName: "orderType",
            multiple: false,
            enableOnChangeFetch: true,
            key: `selectBox-orderType`,
            label: "Order Type",
            items: [],
          },
          {
            type: "autocomplete",
            fieldName: "hub",
            multiple: false,
            enableOnChangeFetch: true,
            key: `autocomplete-hub`,
            label: "Hub",
            items: [],
          },
          {
            type: "autocomplete",
            fieldName: "zones",
            multiple: true,
            key: `autocomplete-deliveryZones`,
            label: "Zones",
            items: [],
          },
          {
            type: "autocomplete",
            fieldName: "deliveryAreas",
            multiple: true,
            key: `autocomplete-deliveryAreas`,
            label: "Delivery Area",
            items: [],
          },
          {
            type: "autocomplete",
            fieldName: "deliveryStatus",
            multiple: true,
            key: `autocomplete-delStatus`,
            label: "Status",
            items: [],
          },
          {
            type: "dateRange",
            fieldName: "dateRange",
            key: `dateRange-filter`,
            placeholderText: "Delivery Date",
            label: "Delivery Date",
            isTextField: true,
            autoUpdateInput: false,
            autoApply: true,
            showDropdowns: true,
            linkedCalendars: true,
            maxSpan: {
              day: "6",
            },
            locale: {},
          },
          {
            type: "timeRange",
            fieldName: "deliveryStartTime",
            multiple: false,
            enableOnChangeFetch: true,
            key: `autocomplete-timeSlotST`,
            label: "Start Time",
            default: "start",
            items: [],
          },
          {
            type: "timeRange",
            fieldName: "deliveryEndTime",
            multiple: false,
            enableOnChangeFetch: true,
            key: `autocomplete-timeSlotET`,
            label: "End Time",
            default: "end",
            items: [],
          },
        ],
        defaultFiltersObjForm: {
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
          },
          deliveryStartTime: "",
          deliveryEndTime: "",
          zones: {
            key: "zones",
            value: [],
          },
          deliveryAreas: {
            key: "deliveryStatus",
            value: [],
          },
          dateRange: {
            startDate: new Date(),
            endDate: new Date(),
          },
          orderType: {
            key: "orderType",
            value: [""],
          },
          hub: {
            key: "hub",
            value: [],
          },
        },
        headerButtons: [
          {
            name: "selectedRow",
            displayName: "",
            disabled: false,
            classes: "customButton",
            hide: true,
          },
        ],
        orderType: [
          { name: "EXPRESS", value: "EXPRESS" },
          { name: "STANDARD", value: "STANDARD" },
        ],
        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 400,
        },
        defaultFiltersObj: {
          hub: {
            key: "hub",
            value: [],
          },
          hubName: {
            key: "hubNames",
            value: [],
          },
          deliveryArea: {
            key: "deliveryArea",
            value: [],
          },
          addressStatus: {
            key: "addressStatus",
            value: [],
          },
          deliveryZone: {
            key: "deliveryZone",
            value: [],
          },
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
          },
          orderType: {
            key: "orderType",
            value: [],
            fieldName: "c.metadata.category",
          },
          status: {
            key: "status",
            value: [],
          },
          paymentType: {
            key: "paymentType",
            value: [],
          },
          deliveryExecutionStatus: {
            key: "deliveryExecutionStatus",
            value: [],
          },
          driverId: {
            key: "driverId",
            value: [],
          },
          deliverySlotTime: {
            key: "deliverySlotTime",
            value: [],
          },
          pageNumber: 0,
          dateRange: {
            key: "dateRange",
            value: {
              startDate: new Date(),
              endDate: new Date(),
            },
          },
        },
        SEARCH_TYPES: [
          {
            name: "Consignment Id",
            value: "consignmentCode",
          },
        ],
        sortModel: {
          field: "deliveryDate",
          direction: "asc",
        },
      },
      NON_TERMINAL_STATUSES: [
        "DELIVERY_ATTEMPTED",
        "DISPATCHED",
        "EXPORTED",
        "OUT_FOR_DELIVERY",
        "PACKING_COMPLETE",
        "PAYMENT_ACCEPTED",
        "PICKING_STARTED",
        "READY",
        "READY_TO_DISPATCH",
      ],
      TAB_VALUES: {
        CONSIGNMENTS: "Consignments",
        COMM_HISTORY: "Communiction History",
      },
      TAB_VALUES_HISTORY: {
        STANDARD: "STANDARD",
        EXPRESS: "EXPRESS",
      },
      ORDER_TYPE: {
        STANDARD: "STANDARD",
        EXPRESS: "EXPRESS",
      },

      FILTER_CHIPS,
      DELIVERY_EXECUTION_STATUS,
      DEFAULT_FILTER_CHIP,
      ALL_FILTER_CHIP,
      NON_EDITABLE_STATUSES,
      REFRESHABLE_STATUSES,
      DRIVER_ASSIGNED_SUCCESS_MSG,
      DEFAULT_STATUS_SELECTION,
      PARTIALLY_DELIVERED,
      REPLANNING_CONSIGNMENT_SUCCESS_MSG,
      ADDRESS_MARKED_UNVERIFIED,
    },
    ...DRIVER_SHARED_CONSTANTS,
    VALIDTION_ADDITIONAL_COMMENT: {
      REASON: {
        REQUIRED: {
          msg: "Please select the reason",
        },
      },
      COMMENT: {
        REQUIRED: {
          msg: "Additional information is required",
        },
      },
    },
  },
  CUSTOMER_COMM_CONSTANTSـSTD: {
    CONSIGNMENTS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Orders",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "hubCode",
            headerName: "Hub Code",
            width: 150,
          },
          {
            field: "hubName",
            headerName: "Hub Name",
            width: 200,
          },
          {
            field: "consignmentId",
            headerName: "Consignment ID",
            width: 150,
          },
          {
            field: "deliveryArea",
            headerName: "Customer Area",
            width: 180,
            tooltip: true,
            tooltipDataKey: "address",
          },
          {
            field: "deliveryZone",
            headerName: "Zone",
            width: 150,
          },
          {
            field: "deliveryStatus",
            headerName: "Status",
            width: 170,
          },
          {
            field: "type",
            headerName: "Type",
            width: 120,
          },
          {
            type: "date",
            field: "deliveryDate",
            headerName: "Delivery Date",
            width: 160,
          },
          {
            field: "startEndTime",
            headerName: "Delivery Slot",
            width: 150,
          },
        ],

        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 400,
        },
        defaultFiltersObj: {
          pageNumber: 0,
          hub: {
            key: "hub",
            value: [],
            fieldName: "c.posInformation.store",
          },
          hubName: {
            key: "hubName",
            value: [],
            fieldName: "c.posInformation.store",
          },
          deliveryArea: {
            key: "deliveryArea",
            value: [],
            fieldName: "c.deliveryInformation.customerContactInfo.address.area",
          },
          addressStatus: {
            key: "addressStatus",
            value: [],
            fieldName:
              "c.deliveryInformation.customerContactInfo.address.status",
          },
          deliveryZone: {
            key: "deliveryZone",
            value: [],
            fieldName: "c.metadata.deliveryZone",
          },
          orderType: {
            key: "orderType",
            value: [],
            fieldName: "c.metadata.category",
          },
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
            fieldName: "c.metadata.deliveryStatus",
          },
          dateRange: {
            key: "dateRange",
            value: {
              startDate: new Date(),
              endDate: new Date(),
            },
          },
          deliverySlot: {
            key: "deliverySlot",
            value: [],
          },
        },
        headerButtons: [
          {
            name: "selectedRow",
            displayName: "",
            disabled: false,
            classes: "customButton",
            hide: true,
          },
        ],
        defaultFiltersObjForm: {
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
            fieldName: "c.metadata.deliveryStatus",
          },
          deliveryStartTime: "",
          deliveryEndTime: "",
          deliveryZone: {
            key: "deliveryZone",
            value: [],
            fieldName: "c.metadata.deliveryZone",
          },
          deliveryArea: {
            key: "deliveryArea",
            value: [],
            fieldName: "c.deliveryInformation.customerContactInfo.address.area",
          },
          dateRange: {
            startDate: new Date(),
            endDate: new Date(),
          },
          orderType: {
            key: "orderType",
            value: [""],
            fieldName: "c.metadata.category",
          },
          hub: {
            key: "hub",
            value: [],
            fieldName: "c.posInformation.store",
          },
        },
        SEARCH_TYPES: [
          {
            name: "Consignment Id",
            value: "c.consignmentCode",
          },
        ],
        sortModel: {
          field: "deliveryDate",
          direction: "asc",
        },
      },
      FILTER_CHIPS: [
        {
          code: "UNPLANNED",
          value: "Unplanned",
        },
        {
          code: "PLANNED",
          value: "Planned",
        },
        {
          code: "PUBLISHED",
          value: "Published",
        },
        {
          code: "PREPARING",
          value: "Preparing",
        },
        {
          code: "PREPARED",
          value: "Prepared",
        },
        {
          code: "OUT_FOR_DELIVERY",
          value: "Out For Delivery",
        },
        {
          code: "COMPLETED",
          value: "Completed",
        },
        {
          code: "ALL",
          value: "All",
        },
      ],
      STATUSES,
      ORDER_STATUS,
      PC_NOT_RECEIVED: "PC_NOT_RECEIVED",
      COMPLETED: "COMPLETED",
      TERMINAL_STATUSES: [
        "DELIVERY_FAILED",
        "CANCELLED",
        "DELIVERED",
        "PARTIALLY_DELIVERED",
        "ON_HOLD",
        "OUT_FOR_DELIVERY",
      ],
      NON_TERMINAL_STATUSES: [
        "NEW",
        "READY_TO_PREPARE",
        "ON_HOLD",
        "OUT_FOR_DELIVERY",
        "ASSIGNED",
        "PACKING_COMPLETE",
        "PENDING_DELIVERY",
        "PREPARED",
        "PREPARING",
        "READY_TO_DISPATCH",
        "RETURNED_TO_STORE/HUB",
      ],
      NON_EDITABLE_STATUSES,
      REFRESHABLE_STATUSES: ["NEW"],
      CANCELLED: "CANCELLED",
      DEFAULT_FILTER_CHIP,
      REPLANNING_CONSIGNMENT_SUCCESS_MSG,
      ADDRESS_MARKED_UNVERIFIED,
      DEFAULT_REPLANNING_SELECTION: "reschedule",
      COD_TEXT: "COD",
      DISPLAY_ROUTE_STATUS_FILTER_OBJ: {
        key: "displayRouteStatus",
        value: ["UNPLANNED"],
        fieldName: "c.metadata.displayRouteStatus",
      },
      CRATE_ID: "Crate Id",
      TAB_VALUES_DETAIL: {
        ORDER_DETAIL: "Order Detail",
        ORDER_LOG: "Order",
      },
    },
    DRIVER_SHARED_CONSTANTS,
    VALIDTION_ADDITIONAL_COMMENT: {
      REASON: {
        REQUIRED: {
          msg: "Please select the reason",
        },
      },
      COMMENT: {
        REQUIRED: {
          msg: "Additional information is required",
        },
      },
    },
  },
  CUSTOMER_COMM_HISTORY_CONSTANTS: {
    CONSIGNMENTS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Consignments",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "hubCode",
            headerName: "Hub",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "hub",
              fieldName: "hub",
              fieldFullName: "hub",
              multiple: true,
              key: `autoComplete-hub`,
              label: "Hub Code",
              items: [],
            },
          },
          {
            field: "hubNames",
            headerName: "Hub Name",
            width: 200,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "hubName",
              fieldName: "hubName",
              fieldFullName: "hubName",
              multiple: true,
              key: `autoComplete-hubName`,
              label: "Hub Name",
              items: [],
            },
          },
          {
            field: "consignmentId",
            headerName: "Consignment ID",
            width: 150,
          },
          {
            field: "deliveryArea",
            headerName: "Customer Area",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryArea",
              fieldName: "deliveryArea",
              fieldFullName: "deliveryArea",
              multiple: true,
              key: `autoComplete-deliveryArea`,
              label: "Area",
              items: [],
            },
          },
          {
            field: "deliveryZone",
            headerName: "Zone",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryZone",
              fieldName: "deliveryZone",
              fieldFullName: "c.metadata.deliveryZone",
              multiple: true,
              key: `autoComplete-deliveryZone`,
              label: "zone",
              items: [],
            },
          },
          {
            field: "orderType",
            headerName: "Type",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "type",
              fieldName: "orderType",
              fieldFullName: "c.metadata.category",
              multiple: true,
              key: `autoComplete-orderType`,
              label: "Order Type",
              items: [],
            },
          },
          {
            type: "date",
            field: "deliveryDate",
            headerName: "Delivery Date",
            width: 150,
            filter: true,
            filterObj: {
              type: "dateRange",
              fieldKey: "deliveryDate",
              fieldName: "dateRange",
              key: `dateRange-filter`,
              placeholderText: "Delivery Date",
              label: "Delivery Date",
              autoUpdateInput: false,
              autoApply: true,
              showDropdowns: true,
              linkedCalendars: true,
              maxSpan: {
                day: "29",
              },
              locale: {},
            },
          },
          {
            type: "date",
            field: "deliveredAt",
            headerName: "Initiated At",
            width: 150,
          },
          {
            field: "initiatedBy",
            headerName: "Initiated By",
            width: 180,
          },
          {
            field: "reasonDescription",
            headerName: "Reason For Delay",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "reason",
              fieldName: "reason",
              fieldFullName: "c.reason",
              multiple: true,
              key: `autoComplete-orderType`,
              label: "reason",
              items: [],
            },
          },
          {
            field: "comment",
            headerName: "Comment",
            width: 180,
          },
        ],
        headerButtons: [
          {
            name: "colsettings",
            displayName: "Column Settings",
            disabled: false,
            childElements: [
              {
                name: "excel",
                displayName: "Export Data",
                disabled: false,
              },
            ],
          },
        ],
        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 400,
        },
        defaultFiltersObj: {
          hub: {
            key: "hub",
            value: [],
          },
          hubName: {
            key: "hubNames",
            value: [],
          },
          deliveryArea: {
            key: "deliveryArea",
            value: [],
          },
          addressStatus: {
            key: "addressStatus",
            value: [],
          },
          deliveryZone: {
            key: "deliveryZone",
            value: [],
          },
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
          },
          orderType: {
            key: "orderType",
            value: [],
          },
          reason: {
            key: "reason",
            value: [],
          },
          status: {
            key: "status",
            value: [],
          },
          paymentType: {
            key: "paymentType",
            value: [],
          },
          deliveryExecutionStatus: {
            key: "deliveryExecutionStatus",
            value: [],
          },
          driverId: {
            key: "driverId",
            value: [],
          },
          deliverySlotTime: {
            key: "deliverySlotTime",
            value: [],
          },
          pageNumber: 0,
          dateRange: {
            key: "dateRange",
            value: {
              startDate: new Date(),
              endDate: new Date(),
            },
          },
        },
        SEARCH_TYPES: [
          {
            name: "Consignment Id",
            value: "consignmentCode",
          },
        ],
        sortModel: {
          field: "deliveryDate",
          direction: "asc",
        },
      },
      
      TAB_VALUES: {
        CONSIGNMENTS: "Consignments",
        COMM_HISTORY: "Communiction History",
      },
      FILTER_CHIPS,
      STATUSES,
      DRIVER_STATUSES,
      ORDER_STATUSES,
      ORDER_STATUS,
      DELIVERY_EXECUTION_STATUS,
      DEFAULT_FILTER_CHIP,
      ALL_FILTER_CHIP,
      NON_EDITABLE_STATUSES,
      REFRESHABLE_STATUSES,
      DRIVER_ASSIGNED_SUCCESS_MSG,
      DEFAULT_STATUS_SELECTION,
      PARTIALLY_DELIVERED,
      REPLANNING_CONSIGNMENT_SUCCESS_MSG,
      ADDRESS_MARKED_UNVERIFIED,
      
    },
    ...DRIVER_SHARED_CONSTANTS,
    VALIDTION_ADDITIONAL_COMMENT: {
      REASON: {
        REQUIRED: {
          msg: "Please select the reason",
        },
      },
      COMMENT: {
        REQUIRED: {
          msg: "Additional information is required",
        },
      },
    },
  },
};

export default CustomerCommConstants;
